import React, { FC } from 'react';

import Button, { IButtonProps } from '@ui/atoms/Button';
import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import TextButton, { IButtonProps as ITextButtonProps } from '@ui/atoms/TextButton';
import WYSIWYGContent, { IWYSIWYGContentProps } from '@ui/atoms/WYSIWYGContent';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import aligned from '@ui/styled/Aligned';
import spaced from '@ui/styled/Spaced';

import { MemberInfo } from '@hooks/useMemberInfo';

import { interpolate } from '@utils/butter';
import { commonLabels } from '@utils/button';
import { getStateName } from '@utils/intake/stateRequirements';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

export interface IMemberAppointmentInfoStepPageContent {
	pageHeader: string;
	pageInfo: string;
}

interface IMemberAppointmentInfoStepProps extends IFlowStepComponentProps {
	pageContent: IMemberAppointmentInfoStepPageContent;
	member?: MemberInfo;
	hideNavBack: boolean;
}

const SpacedHeader = spaced(HeadingText);
const SpacedWYSIWYG = spaced<IWYSIWYGContentProps>(WYSIWYGContent);
const SpacedButton = spaced<IButtonProps>(Button);
const AlignedTextButton = aligned<ITextButtonProps>(TextButton);

const MemberAppointmentInfoStep: FC<IMemberAppointmentInfoStepProps> = ({
	hideNavBack,
	member,
	pageContent,
	handleNavNext = () => {},
	handleNavBack = () => {},
	stepKey,
}) => {
	const { pageHeader, pageInfo } = pageContent;

	return (
		<CenteredGridItem>
			<FlexColumn>
				<SpacedHeader marginBottom="sm">{pageHeader}</SpacedHeader>
				<SpacedWYSIWYG
					marginBottom="lgxl"
					dangerouslySetInnerHTML={{
						__html: interpolate(pageInfo, {
							state: getStateName(member?.stateOfResidence?.abbreviation),
						}),
					}}
				/>
				<SpacedButton
					label={commonLabels.continue}
					variant="secondary"
					marginBottom="lg"
					onClick={() => handleNavNext(stepKey)}
				/>
				{!hideNavBack && (
					<AlignedTextButton
						underline
						variant="text"
						alignSelf="center"
						label={commonLabels.back}
						onClick={() => handleNavBack(stepKey)}
					/>
				)}
			</FlexColumn>
		</CenteredGridItem>
	);
};

export default MemberAppointmentInfoStep;
